import MainRoutes from "routes";

function App() {
  return <MainRoutes />;
}

export default App;
